module.exports = __webpack_public_path__ + "d2eec4795cf3a2c1f8927ce7f8858b9b.jpg";